import { useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
// project imports
// import useConfig from 'hooks/useConfig';
import LogoSection from '../LogoSection';
// import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
// import MegaMenuSection from './MegaMenuSection';
// import NotificationSection from './NotificationSection';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

import config, { ThemeMode } from 'config';
import ExtensionModal from './ExtensionModal';
import { getCurrentUser } from 'api_handlers/auth';
import { toggleDrawerOpen } from 'actions/planner2';

// assets
import MenuIcon from '@mui/icons-material/Menu';
import { Button, Grid, IconButton, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import BrandMultiSelect from 'components/Common/BrandMultiSelect';
import { useStaffAccess } from '../../../../customRoutes/StaffRoute';

import mixpanel from '../../../../utils/mixpanel';
import FeedbackLauncher from 'components/feedback/FeedbackLauncher';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();
  const history = useHistory();
  const { mode } = config;
  const isHorizontal = false;
  const [extensionModal, setExtensionModal] = useState(false);

  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('user') || '{}'));
  const isSuperuser = !!user.is_superuser;
  const isStaff = useStaffAccess();
  const canSwitchBrand = isSuperuser || !!isStaff;

  useEffect(() => {
    const extension = parseInt(localStorage.getItem('extension'));
    const extensionTime = parseInt(localStorage.getItem('extensionTime'));
    const popUp = localStorage.getItem('popUpAppearance');
    var time = new Date().getTime();
    // console.log('popUpAppearance',popUp)
    getCurrentUser().then((resp) => {
      if (!resp.data.extension_installed && popUp !== 'doNotShowpopUp') {
        if (extension === 1) {
          setTimeout(() => {
            setExtensionModal(true);
          }, 3000);
        } else if (extension === 2 && time >= extensionTime + 1000 * 60 * 60 * 24 * 3) {
          setTimeout(() => {
            setExtensionModal(true);
          }, 3000);
        } else if (extension === 3 && time >= extensionTime + 1000 * 60 * 60 * 24 * 7) {
          setTimeout(() => {
            setExtensionModal(true);
          }, 3000);
        } else if (extension === 4 && time >= extensionTime + 1000 * 60 * 60 * 24 * 7) {
          setTimeout(() => {
            setExtensionModal(true);
          }, 3000);
        } else if (extension === 5 && time >= extensionTime + 1000 * 60 * 60 * 24 * 7) {
          setTimeout(() => {
            setExtensionModal(true);
          }, 3000);
        } else if (extension === 6 && time >= extensionTime + 1000 * 60 * 60 * 24 * 7) {
          setTimeout(() => {
            setExtensionModal(true);
          }, 3000);
        }
        // console.log('extension', extension, time >= extensionTime + 1000 * 10);
        // console.log('extension_installed', resp.data.extension_installed);
      }
    });
  }, []);

  return (
    <>
      {/* logo & toggler button */}
      <Box sx={{ width: downMD ? 'auto' : 228, display: 'flex' }}>
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
        {!isHorizontal && (
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              overflow: 'hidden',
              transition: 'all .2s ease-in-out',
              bgcolor: mode === ThemeMode.DARK ? 'dark.main' : 'secondary.light',
              color: mode === ThemeMode.DARK ? 'secondary.main' : 'secondary.dark',
              '&:hover': {
                bgcolor: mode === ThemeMode.DARK ? 'secondary.main' : 'secondary.dark',
                color: mode === ThemeMode.DARK ? 'secondary.light' : 'secondary.light',
              },
            }}
            onClick={() => dispatch(toggleDrawerOpen())}
            color="inherit"
          >
            <MenuIcon stroke={1.5} size="20px" />
          </Avatar>
        )}
      </Box>

      {/* header search */}
      {/* <SearchSection /> */}
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      {/* mega-menu */}
      {/* <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <MegaMenuSection /> 
            </Box> */}

      {/* notification */}
      {/* <NotificationNotificationSection /> */}

      {/* profile */}
      <Button
        variant="contained"
        sx={{
          borderRadius: '50px',
          color: '#000',
          fontSize: '9px',
          fontWeight: '600',
          textTransform: 'none',
          justifyContent: 'center',
          alignItems: 'center',
          height: '40px',
        }}
        onClick={async () => {
          setExtensionModal(true);
          mixpanel.track('Chrome-Extension-Download-Click', {
            'from': 'Header'
          });
        }}
      >
        <Grid container justifyContent={'center'} alignItems={'center'}>
          <Grid item style={{marginTop:'5px'}}>
            <SystemUpdateAltIcon
              sx={{ fontSize: '13px', marginRight: '10px'}}
            ></SystemUpdateAltIcon>
          </Grid>
          <Grid item>
            <Typography sx={{fontSize:'13px'}}> Download Extension</Typography>
          </Grid>
        </Grid>
      </Button>
      {canSwitchBrand && (
        <BrandMultiSelect
          user={user}
          onChange={(brands) => setUser({ ...user, brands })}
        />
      )}

      {/* {
        showExtension==='yes'?
        <ExtensionModal
          open={true}
          close={(val) => setExtensionModal(val)}
        ></ExtensionModal>
        :''
      } */}
      {extensionModal ? (
        <ExtensionModal
          open={extensionModal}
          close={(val) => setExtensionModal(val)}
        ></ExtensionModal>
      ) : (
        ''
      )}

      {/* Sits beside help on purpose: the two things someone reaches for
          when a screen is not doing what they want. */}
      <FeedbackLauncher />

      <IconButton sx={{ml:'10px'}}>
        <HelpOutlineIcon
          sx={{ fontSize: '30px' }}
          onClick={() => {
            history.push('/planner/help-and-support');
          }}
        ></HelpOutlineIcon>
      </IconButton>
      <ProfileSection />
    </>
  );
};

export default Header;
